import { customShadows } from './shadows';

// Overrides de componentes MUI para lograr el look de un dashboard admin

export default function componentsOverride(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': { boxSizing: 'border-box' },
        html: { width: '100%', height: '100%' },
        body: { width: '100%', height: '100%' },
        '#root': { width: '100%', height: '100%' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
        sizeLarge: { height: 48 },
        containedPrimary: { boxShadow: customShadows.primary },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: customShadows.card,
          position: 'relative',
          zIndex: 0,
        },
      },
    },
    MuiCardHeader: {
      defaultProps: { titleTypographyProps: { variant: 'h6' }, subheaderTypographyProps: { variant: 'body2' } },
      styleOverrides: { root: { padding: theme.spacing(3, 3, 0) } },
    },
    MuiCardContent: {
      styleOverrides: { root: { padding: theme.spacing(3) } },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        outlined: { borderColor: theme.palette.divider },
      },
    },
    MuiAppBar: {
      defaultProps: { color: 'transparent' },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { borderRightStyle: 'dashed' },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 6 } },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
          fontWeight: theme.typography.fontWeightBold,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: { root: { borderRadius: 4 } },
    },
  };
}
